import { render, staticRenderFns } from "./DisplayValidationErrorMessages.vue?vue&type=template&id=5851b924&scoped=true&"
import script from "./DisplayValidationErrorMessages.vue?vue&type=script&lang=js&"
export * from "./DisplayValidationErrorMessages.vue?vue&type=script&lang=js&"
import style0 from "./DisplayValidationErrorMessages.vue?vue&type=style&index=0&id=5851b924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5851b924",
  null
  
)

export default component.exports